<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营商管理</el-breadcrumb-item>
      <el-breadcrumb-item>协议模板</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入模板名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Name" label="协议模板名称" min-width="25%"></el-table-column>
          <el-table-column prop="Jiafang" label="甲方" min-width="15%"></el-table-column>
          <el-table-column prop="Yifang" label="乙方" min-width="15%"></el-table-column>
          <el-table-column prop="Bingfang" label="丙方" min-width="15%"></el-table-column>
          <el-table-column prop="" label="点击查看" min-width="15%">
            <template v-slot="scope">
              <el-link  size="mini" style="margin-left: 0; margin-right: 5px;color: #48c9b0" :href="scope.row.Url" target="_blank">查看模板文件</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="15%"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyAgreementTemplate',
  data () {
    return {
      activeName: 'first',
      // 查询
      keywords: {
        name: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetAgreementTemplateNum()
    this.apiGetAgreementTemplateList()
  },
  methods: {
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetAgreementTemplateNum()
      this.apiGetAgreementTemplateList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetAgreementTemplateList()
    },
    apiGetAgreementTemplateNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetAgreementTemplateNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetAgreementTemplateList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        name: that.keywords.name
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetAgreementTemplateList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
